
import { useState } from 'react';
import { useProfiles } from './hooks/useProfiles';
import CollapsedSidebar from './CollapsedSidebar';
import ExpandedSidebar from './ExpandedSidebar';
import MainContent from './MainContent';
import { SocialProfilesProps } from './types';

const SocialProfilesView = ({ handlePageChange, activePage, requireSubscription = false }: SocialProfilesProps) => {
  // Define state variables first
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  // Determine if we're in single selection mode
  const isSingleSelectionMode = activePage === 'reports';
  
  // Always call hooks unconditionally at the top level
  const {
    profiles,
    isLoading,
    selectedProfiles,
    singleSelectedProfile,
    setSingleSelectedProfile,
    toggleProfileSelection
  } = useProfiles(isSingleSelectionMode);

  // Render based on collapsed state
  if (isCollapsed) {
    return (
      <div className="flex h-full w-full">
        <CollapsedSidebar
          setIsCollapsed={setIsCollapsed}
          isLoading={isLoading}
          filteredProfiles={profiles}
          toggleProfileSelection={toggleProfileSelection}
          isSingleSelectionMode={isSingleSelectionMode}
          singleSelectedProfile={singleSelectedProfile}
          selectedProfiles={selectedProfiles}
          handlePageChange={handlePageChange}
          requireSubscription={false}
          isSubscriptionActive={true}
        />
        
        <MainContent
          activePage={activePage}
          selectedProfiles={selectedProfiles}
          singleSelectedProfile={singleSelectedProfile}
          isSingleSelectionMode={isSingleSelectionMode}
          profiles={profiles}
        />
      </div>
    );
  }

  // If the interface is expanded
  return (
    <div className="flex h-full w-full">
      <ExpandedSidebar
        handlePageChange={handlePageChange}
        setIsCollapsed={setIsCollapsed}
        profiles={profiles}
        isSingleSelectionMode={isSingleSelectionMode}
        selectedProfiles={selectedProfiles}
        singleSelectedProfile={singleSelectedProfile}
        toggleProfileSelection={toggleProfileSelection}
        setSingleSelectedProfile={setSingleSelectedProfile}
        isLoading={isLoading}
        requireSubscription={false}
        isSubscriptionActive={true}
      />
      
      <MainContent
        activePage={activePage}
        selectedProfiles={selectedProfiles}
        singleSelectedProfile={singleSelectedProfile}
        isSingleSelectionMode={isSingleSelectionMode}
        profiles={profiles}
      />
    </div>
  );
};

export default SocialProfilesView;
